import React from 'react';
import PropTypes from 'prop-types';
//Componentes
import { Link } from 'react-router-dom';
//Componentes material
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
//Ícones
import HomeIcon from '@material-ui/icons/Home';
import MeetingRoomIcon from '@material-ui/icons/MeetingRoom';
import BusinessIcon from '@material-ui/icons/Business';
import PersonIcon from '@material-ui/icons/Person';
import ListAltIcon from '@material-ui/icons/ListAlt';
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck';
import TrendingUpIcon from '@material-ui/icons/TrendingUp';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import BuildIcon from '@material-ui/icons/Build';
//Controllers
import LoginController from '../controllers/LoginController';
import PermissaoController, { modulos, perfilAcesso } from '../controllers/PermissaoController';
import Imagem from './Imagem';

/**
 * Componente contendo os itens do menu da aplicação
 */
class Menu extends React.Component {
    constructor(props) {
        super(props);
        //Inicializando controllers
        this.loginController = new LoginController();
        this.permissaoController = new PermissaoController();
        //Bindings
        this.handleSairClick = this.handleSairClick.bind(this);
    }

    /**
     * Evento disparado ao clicar no item de logout.
     * Efetura o logout da aplicação e dispara um callback
     */
    async handleSairClick() {
        await this.loginController.logout();
        if (this.props.onLogout)
            this.props.onLogout();
    }

    /**
     * Renderiza os itens do menu disponíveis para o usuário logado
     * @param {Boolean} perfilCliente Indica se o usuário logado é um cliente
     * @param {Object} permissoes Objeto com as permissões do usuário
     * @param {Boolean} permiteCadastrarAdmin Indica se o usuário pode cadastrar administradores
     * @returns {React.Component} Retorna os itens do menu para o usuário
     */
    renderItensMenu(perfilCliente, permissoes) {

        if (perfilCliente)
            return null;
        else {
            return (
                <React.Fragment>
                    <List>
                        <ListItem button component={Link} to="/" aria-label="Página inicial" >
                            <ListItemIcon>
                                <HomeIcon />
                            </ListItemIcon>
                            <ListItemText>
                                Página inicial
                            </ListItemText>
                        </ListItem>
                        {
                            permissoes[modulos.ADMINISTRADORES] && (
                                <ListItem button component={Link} to="/administrador" aria-label="Administradores" >
                                    <ListItemIcon>
                                        <BuildIcon />
                                    </ListItemIcon>
                                    <ListItemText>
                                        Administradores
                                    </ListItemText>
                                </ListItem>
                            )
                        }
                        {
                            permissoes[modulos.EMPRESAS] && (
                                <ListItem button component={Link} to="/empresa" aria-label="Empresas" >
                                    <ListItemIcon>
                                        <BusinessIcon />
                                    </ListItemIcon>
                                    <ListItemText>
                                        Empresas
                                    </ListItemText>
                                </ListItem>
                            )
                        }
                        {
                            permissoes[modulos.AVALIADORES] && (
                                <ListItem button component={Link} to="/avaliador" aria-label="Avaliadores" >
                                    <ListItemIcon>
                                        <AssignmentIndIcon />
                                    </ListItemIcon>
                                    <ListItemText>
                                        Avaliadores
                                    </ListItemText>
                                </ListItem>
                            )
                        }
                        {
                            permissoes[modulos.CLIENTES] && (
                                <ListItem button component={Link} to="/cliente" aria-label="Clientes" >
                                    <ListItemIcon>
                                        <PersonIcon />
                                    </ListItemIcon>
                                    <ListItemText>
                                        Clientes
                                    </ListItemText>
                                </ListItem>
                            )
                        }
                        {
                            permissoes[modulos.QUESTIONARIOS] && (
                                <ListItem button component={Link} to="/questionario" aria-label="Questionários" >
                                    <ListItemIcon>
                                        <ListAltIcon />
                                    </ListItemIcon>
                                    <ListItemText>
                                        Questionários
                                    </ListItemText>
                                </ListItem>
                            )
                        }
                        {
                            permissoes[modulos.AVALIACOES] && (
                                <ListItem button component={Link} to="/avaliacao" aria-label="Avaliações" >
                                    <ListItemIcon>
                                        <PlaylistAddCheckIcon />
                                    </ListItemIcon>
                                    <ListItemText>
                                        Avaliações
                                    </ListItemText>
                                </ListItem>
                            )
                        }
                        {
                            permissoes[modulos.RESULTADOS] && (
                                <ListItem button component={Link} to="/resultado" aria-label="Resultados" >
                                    <ListItemIcon>
                                        <TrendingUpIcon />
                                    </ListItemIcon>
                                    <ListItemText>
                                        Resultados
                                    </ListItemText>
                                </ListItem>
                            )
                        }
                    </List>
                    <Divider />

                </React.Fragment>
            );
        }

    }

    render() {
        const { permissoes, usuario, empresa } = this.props;
        const perfilCliente = perfilAcesso.CLIENTES.includes(usuario.perfilAcesso);
        //Extraindo primeiro nome do usuário
        const nomeUsuario = usuario.nome && usuario.nome.split(' ')[0];
        
        return (
            <React.Fragment>
                <List> 
                    {
                        empresa && empresa.logo && (
                            <ListItem>
                                <Imagem src={empresa.logo} alt={empresa.nome} maxWidth={170} />
                            </ListItem>
                        )
                    }
                    <ListItem>
                        <ListItemText>Olá, {nomeUsuario}</ListItemText>
                    </ListItem>
                </List>
                <Divider />
                { this.renderItensMenu(perfilCliente, permissoes) }
                <List>
                    <ListItem button aria-label="Sair" onClick={this.handleSairClick} >
                        <ListItemIcon>
                            <MeetingRoomIcon />
                        </ListItemIcon>
                        <ListItemText>
                            Sair
                        </ListItemText>
                    </ListItem>
                </List>
            </React.Fragment>
        );
    }
}

Menu.propTypes = {
    /** Callback executado quando o usuário realiza logout do sistema */
    onLogout: PropTypes.func,
    /** Dados do usuário autenticado */
    usuario: PropTypes.object.isRequired,
    /** Empresa relacionada ao usuário */
    empresa: PropTypes.object,
    /** Objeto contendo as permissões do usuário */
    permissoes: PropTypes.object.isRequired,
};

export default Menu;